module.exports = __webpack_public_path__ + "static/william-5b145a1369e5a81f86f9c3ffdf3b6bf5.jpg";